module.exports = __webpack_public_path__ + "img/real-person-icon.3b4ee3a2.png";